import React from "react";
import { HTMLGridTableCellElement, HTMLGridTableElement } from "../../../ComponentInterface";
import SmetaAxios from "../../../SmetaAxios";
import { AxiosRequest } from "../../../Url";
import DialogDepNames from "../../Module/Dialogs/DialogDepNames";
import { ObjType } from "../../Tools/Consts";
import { smetaModals } from "../../Tools/modalManager";
import { DelphiColors, EditStyle, Prefixes } from "../../Tools/ProjectX";
import { getParamObjectValues, getTableLayout } from "../../Tools/Requests";
import { defaultFieldInfo, getRightsData, setColor } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";
import { SmetaGridField } from "../SmetaGridConst";
import { parseGridState } from "../../Sections/ElementsSections/SectionDocuments/DocumentsConsts";

export async function departmentsGrid(grid: createGrid, source: createRecordSource, props, data) {
  const json = await getTableLayout({ module: props.Module, objType: ObjType.Department, sectionId: props.SectionID });
  let state;
  if (json.State) {
    state = json.State;
  }
  if (json.Columns && json.Columns.State) {
    state = json.Columns.State;
  }
  if (state) {
    state = parseGridState(state);
    source.setGridState(state);
  }

  source.onHandleRequest = handleRequest(props);
  //создание стилей для сворачивающихся записей
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;
  grid.setUnderlineCell = (col: SmetaGridField, div: HTMLDivElement) => {
    if (col.fieldName !== "Title" || col.title !== "Организация") return;
    const id = source.getFieldValueSync("Name");
    if (!id || id < 0) return;
    div.classList.add("grid-cell-inner-underline");
  };
  grid.changeGridStyles = async (table: HTMLGridTableElement) => {
    const departNameId = await source.getFieldValue("Name");
    const isFavorite = (await source.getFieldValue("Favorite")) !== undefined;
    table.querySelectorAll<HTMLGridTableCellElement>(".grid-td").forEach(async (cell) => {
      const { fieldName, title } = cell.field;
      if (!fieldName) return;
      if (departNameId > 0 && title === "Организация (подразделение)") cell.style.textDecoration = "underline";
      const fieldText = await source.getFieldText(fieldName);
      const fieldValue = await source.getFieldValue(fieldName);
      const hasTextAndIsEmpty = fieldText && fieldValue === undefined;
      if (fieldName !== "Code" && isFavorite) cell.style.color = setColor(DelphiColors.clBlue);
      if (fieldName !== "Title" && hasTextAndIsEmpty) cell.style.color = setColor(DelphiColors.clGray);
    });
  };
  await source.open();
  // source.setKeyFieldName("Code");

  const departsTitleDropDownList = async () => {
    const json = await getParamObjectValues(Prefixes.orgs, ObjType.ChildOrg);
    const list = Object.values(json.Items).map((item) => {
      return { label: item.text, id: item.id };
    });
    if ((await source.getFieldValue("Name")) > 0) list.push({ label: "(отключить организацию)", id: "-1" });
    return list;
  };
  const departsTitleEditButtonClick = async (subData) => {
    smetaModals.open(
      <DialogDepNames
        departsId={await source.getFieldText("ID")}
        onSelect={async () => {
          subData.props.onEdit({
            noEdit: true,
          });
          await source.refreshRecord();
          await grid.updateGridSize();
        }}
      />,
      {
        Title: `Код подразделения: ${await source.getFieldText("Code")}`,
        hiddenButton: true,
        blockMaximize: true,
        blockResize: true,
        blockSaveLocation: true,
        style: { height: "400px", width: "590px" },
      },
    );
  };
  const departsTitleCloseUpList = async (data) => {
    await grid.postSomeData(
      "Title",
      data.tag === "-1" ? { text: await source.getFieldText("Title") } : { id: data.tag },
    );
    await grid.postExicstedEditRec(true);
  };
  //создание дефолтных полей()
  let columns = {
    title: [
      {
        fieldName: "Code",
        title: "Код подразделения",
        width: 120,
        level: 0,
        collapseRecord: true,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "Title",
        title: "Организация (подразделение)",
        width: 200,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: EditStyle.PickList + EditStyle.Ellipsis,
          onDropDownList: departsTitleDropDownList,
          onEditButtonClick: departsTitleEditButtonClick,
          onCloseUpList: departsTitleCloseUpList,
        },
      },
      {
        fieldName: "Title",
        title: "Название",
        width: 200,
        level: 1,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "ShortName",
        title: "Краткий код",
        width: 120,
        level: 1,
        fieldInfo: { ...defaultFieldInfo },
      },
      {
        fieldName: "DepTypes",
        title: "Тип подразделения",
        width: 120,
        level: 1,
        fieldInfo: { ...defaultFieldInfo, EditStyle: EditStyle.CheckList },
      },
      {
        fieldName: "Options",
        title: "Параметры отдела",
        width: 120,
        level: 1,
        fieldInfo: { ...defaultFieldInfo, EditStyle: EditStyle.CheckList },
      },
      {
        fieldName: "KeyNo",
        title: "№",
        width: 38,
        level: 0,
        fieldInfo: { ...defaultFieldInfo },
      },
    ],
  };

  //парсинг полей запроса GetTableLayout
  if (json) {
    source.rights = getRightsData(json.Rights);

    columns = parseColumns(json, { inputColumns: columns });
    grid.setColumns(columns);
  } else grid.setColumns(columns);

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async function (source: createRecordSource) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };

    if (data.Pages && json.Pages) {
      data.Pages.current = json.Pages.split("\r\n").map((page) => {
        return { Caption: page };
      });
    }
  }

  source.onRecordCollapsed = async function (event) {
    const recordIndex =
      event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : await event;
    await SmetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, ObjType: ObjType.Department, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
    if (data.setCountRecords) data.setCountRecords(source.recordCount);
  };

  await grid.setSource(source);

  if (props.ID) await grid.refreshSource(props.ID);
  if (data.setSelectedRecord) {
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }

  await grid.updateGridSize();
}

function handleRequest(props) {
  return (request) => {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", ObjType.Department)
      .set("SectionID", props.SectionID)
      .set("All"); //TODO spUsers.Visible Нажата ли кнопка "Пользователи"
    return AxiosRequest(true, params, request);
  };
}
